export default [
  {
    path: '/users',
    name: 'supplier-admin.manage-users',
    redirect: { name: 'supplier-admin.manage-users.search' },
    meta: {
      breadcrumb: 'Users',
    },
    component: {
      render(c) { return c('router-view'); },
    },
    children: [
      {
        path: 'search',
        name: 'supplier-admin.manage-users.search',
        meta: {
          breadcrumb: 'Search',
        },
        component: () => import('@/pages/supplier/_admin/manage_users'),
      },
      {
        path: 'user/:user',
        name: 'supplier-admin.manage-users.edit-user',
        meta: {
          breadcrumb() {
            return 'User';
          },
        },
        component: () => import('@/pages/supplier/_admin/manage_user'),
      },
    ],
  },
  {
    path: '/organization/:organization',
    name: 'supplier-admin.manage-organization',
    component: () => import('@/pages/supplier/_admin/manage_organization'),
    meta: {
      breadcrumb: 'Organization',
    },
  },
];




// WEBPACK FOOTER //
// ./src/router/routes/supplier_admin.js